import { Panel } from 'rsuite';
import "./NoResource.css"

export function NoResource () {
    return (
        <p className="noResource">
            You have no contributions yet.

            Post an article, video, or other resource that helped you better understand course material!
        </p>
    )
}
